export default (unauthedRoutes, applicantRoute, adminRoute, clientRoute) =>
  store => (nextRouterState, replace, cb) => {
    const {
      user: {
        loggedIn,
        roles,
        statusGroups
      }
    } = store.getState();

  const [rootParam, firstParam, secondParam] = nextRouterState.location.pathname.split('/');
  const adminPages = ['guide'];

  const publicRoutes = ~unauthedRoutes.indexOf((firstParam || rootParam).toLowerCase());

  // Redirect user to root if they're not authed and go to authed route
  if(!loggedIn && !publicRoutes) {
    replace('/login');
    return cb();
  }

  // Catch a unsual error.
  if(loggedIn && !roles) return console.error('somehow roles array was not returned from back end');

  // redirect to respective workspace.
  if(loggedIn && (firstParam === 'login' || firstParam === '')) {

        if (roles.includes('Admin') || roles.includes('Employee')) {

          if(roles.includes('Qualifying Specialist')) {
            replace(`/${adminRoute}/${statusGroups[0]}`);
          }else if(roles.includes('Placement Specialist')) {
            replace(`/${adminRoute}/${statusGroups[0]}`);
          }else if(roles.includes('Relationship Manager')) {
            replace(`/${adminRoute}/${statusGroups[0]}`);
          }else if(roles.includes('Client Adviser')) {
            replace(`/${adminRoute}/contacts`);
          }else{
            replace(`/${adminRoute}/${statusGroups[0]}`);
          }
          
        }

        if (roles.includes('Client')) {
          replace(clientRoute);
        }

        if (roles.includes('Applicant')) {
          replace(applicantRoute);
        }
      return cb();
    }

    // Something related to guide(?) ...

    if(firstParam === 'admin' && !~adminPages.indexOf[secondParam] && statusGroups && !~statusGroups.indexOf(nextRouterState.params.navColumnState)) {
        replace(`/${adminRoute}/${statusGroups[0]}`);
    }

    return cb();

};



// WEBPACK FOOTER //
// ./shared/utils/authRedirectGen.js